<template>
	<div>
		<v-dialog v-model="fieldTypeDialog" no-click-animation persistent scrollable content-class="full-height select_field_dialog" lazy transition="dialog-bottom-transition">
	        <v-card>
	        	<v-card-title noshadow>Select Field Type</v-card-title>
	        	<v-divider></v-divider>
		        <v-card-text full-height>
		        	<v-radio-group v-model="dataType" right-align-radio>
			            <!-- <v-radio :label="item.title" :value="item.value" v-for="(item, index) in dataTypes" :key="index" @change="setFieldType(item)" :disabled="item.value=='groupField'">
			            </v-radio> -->
			            <v-radio :label="item.title" :value="item.value" v-for="(item, index) in dataTypes" :key="index" @change="setFieldType(item.value)" :disabled="item.value=='groupField'">
			            </v-radio>
			        </v-radio-group>
		        </v-card-text>
		        <v-divider></v-divider>
		        <v-card-actions>
		        	<v-spacer></v-spacer>
          			<v-btn small color="blue darken-1" flat @click="$parent.fn_closeDialog">close</v-btn>
		          	<!-- <v-btn small color="blue darken-1" flat @click="$parent.fn_closeDialog">ok</v-btn> -->
		        </v-card-actions>
		    </v-card>

	    </v-dialog>
	</div>
</template>

<script>
	export default{
		props:['setFieldType', 'dataTypes', 'fieldType'],
		data(){
			return{
				// dataTypes:[
				// 	{"id":1,  "value":"text", "title":"Text",  "maxLength":250}, 
				// 	{"id":2,  "value":"pincode", "title":"Pincode", "maxLength":8}, 
				// 	{"id":3,  "value":"mobileNumber", "title":"Mobile Number", "maxLength":12}, 
				// 	{"id":4,  "value":"email", "title":"Email", "maxLength":250}, 
				// 	{"id":5,  "value":"dateTime", "title":"Date Time", "maxLength":0}, 
				// 	{"id":6,  "value":"longText", "title":"Long Text", "maxLength":250}, 
				// 	{"id":7,  "value":"number", "title":"Number", "maxLength":10}, 
				// 	{"id":8,  "value":"decimal", "title":"Decimal", "maxLength":10}, 
				// 	{"id":9,  "value":"choice", "title":"Choice", "maxLength":0}, 
				// 	{"id":10, "value":"yes/no", "title":"Yes/No", "maxLength":0}, 
				// 	{"id":11, "value":"code", "title":"Code", "maxLength":0}, 
				// 	{"id":12, "value":"linkedItem", "title":"Linked Item", "maxLength":0}, 
				// 	{"id":13, "value":"groupField", "title":"Group Field (Coming Soon)", "maxLength":0}, 
				// 	{"id":14, "value":"accountItem", "title":"Account Item", "maxLength":0}, 
				// 	{"id":15, "value":"location", "title":"Location", "maxLength":0}, 
				// 	{"id":16, "value":"phoneNumber", "title":"Phone Number", "maxLength":100}
				// ],
				dataType:'text',
				fieldTypeDialog:false
			}
		},
		methods:{
			openDialogWeb: function () {
				// this.dataType = this.fieldType.value;
				this.dataType = this.fieldType;
				this.fieldTypeDialog = true;
			},
			closeDialogWeb: function () {
				this.fieldTypeDialog = false;
			}
		},
	}
</script>


// WEBPACK FOOTER //
// src/components/fields/dialog_fieldtype.vue